import { useState } from "react";
import { T } from "../constants";

export default function FilterBar({ filterButtons, activeType, onTypeChange }) {
  const [hoveredFilter, setHoveredFilter] = useState(null);

  return (
    <div style={{
      background: T.mossDeep,
      borderBottom: "1px solid rgba(0,0,0,0.15)",
      padding: "0 2rem",
      display: "flex", gap: "4px",
    }}>
      {filterButtons.map(btn => {
        const isActive = activeType === btn.key;
        const isHovered = hoveredFilter === btn.key && !isActive;
        return (
          <button
            key={btn.key}
            onClick={() => onTypeChange(btn.key)}
            onMouseEnter={() => setHoveredFilter(btn.key)}
            onMouseLeave={() => setHoveredFilter(null)}
            style={{
              fontSize: "0.8rem",
              padding: "11px 14px",
              border: "none",
              borderBottom: isActive ? `2px solid ${T.lime}` : "2px solid transparent",
              background: "transparent",
              color: isActive ? T.lime : isHovered ? T.headerText : "rgba(240,247,235,0.6)",
              fontWeight: isActive ? 500 : 400,
              cursor: "pointer",
              fontFamily: "'DM Sans', sans-serif",
              transition: "color 0.12s",
              marginBottom: "-1px",
            }}
          >
            {btn.label}
          </button>
        );
      })}
    </div>
  );
}
